import Reveal from "@/components/Reveal";
import { ShieldCheck } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Titolare del trattamento",
    body: [
      "Il titolare del trattamento dei dati personali è l'Associazione Vittime del Debito, C.F. / P.IVA 14869890963, con sede legale in Via Pordenone 13, 20132 Milano (MI) e sede operativa in Via Scipione Ronchetti 8, 21013 Gallarate (VA).",
      "Per qualsiasi domanda su questa informativa o sui tuoi dati puoi scrivere a info@associazionevittimedeldebito.it.",
    ],
  },
  {
    title: "2. Quali dati raccogliamo",
    body: [
      "Raccogliamo solo i dati che ci fornisci volontariamente attraverso il sito:",
      "Modulo di iscrizione: nome, cognome, email e città.",
      "Modulo di richiesta assistenza: nome, cognome, email, telefono (facoltativo), città, fascia di debito indicativa, descrizione della tua situazione ed eventuale segnalazione di disagio psicologico.",
      "Prenotazione colloqui: nome, cognome, email, telefono, sede, data e ora scelte ed eventuale nota.",
      "Assistente virtuale (chat): il contenuto dei messaggi che scrivi, utilizzato per risponderti.",
      "Non raccogliamo dati di pagamento: tutti i nostri servizi sono gratuiti.",
    ],
  },
  {
    title: "3. Perché usiamo i tuoi dati (finalità e base giuridica)",
    body: [
      "Gestione della tua iscrizione gratuita all'associazione e invio di comunicazioni associative (base: esecuzione del rapporto associativo).",
      "Presa in carico della tua richiesta di assistenza e ricontatto da parte dei nostri operatori (base: esecuzione di misure precontrattuali su tua richiesta).",
      "Organizzazione dei colloqui in sede da te prenotati (base: esecuzione di misure precontrattuali su tua richiesta).",
      "Attivazione del supporto psicologico nei casi più gravi, solo se lo segnali tu esplicitamente (base: tuo consenso esplicito, trattandosi di un dato particolare).",
      "Miglioramento del servizio di assistenza virtuale (base: legittimo interesse).",
    ],
  },
  {
    title: "4. Chi può vedere i tuoi dati",
    body: [
      "I tuoi dati sono visibili solo agli operatori e ai volontari autorizzati dell'associazione, formati alla riservatezza.",
      "Non vendiamo, non cediamo e non comunichiamo i tuoi dati a nessuno per scopi commerciali o pubblicitari.",
      "Alcuni fornitori tecnici (servizio di hosting e servizio di intelligenza artificiale per l'assistente virtuale) trattano i dati solo per far funzionare il sito, secondo accordi conformi al GDPR.",
    ],
  },
  {
    title: "5. Quanto conserviamo i tuoi dati",
    body: [
      "Iscrizione: finché resti socio; puoi cancellarti in qualsiasi momento con una email.",
      "Richieste di assistenza e prenotazioni: per il tempo necessario a gestire la tua pratica e comunque non oltre 24 mesi dalla sua chiusura.",
      "Conversazioni con l'assistente virtuale: fino a 12 mesi, per migliorare il servizio.",
    ],
  },
  {
    title: "6. I tuoi diritti",
    body: [
      "In qualsiasi momento puoi esercitare i diritti previsti dagli articoli 15-22 del GDPR: accesso ai tuoi dati, rettifica, cancellazione, limitazione del trattamento, portabilità e opposizione.",
      "Puoi anche revocare il consenso in qualsiasi momento, senza alcuna conseguenza.",
      "Per esercitare i tuoi diritti scrivi a info@associazionevittimedeldebito.it: ti risponderemo entro 30 giorni.",
    ],
  },
  {
    title: "7. Reclamo al Garante",
    body: [
      "Se ritieni che il trattamento dei tuoi dati non rispetti la legge, puoi presentare reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
    ],
  },
  {
    title: "8. Cookie e strumenti tecnici",
    body: [
      "Il sito usa solo cookie tecnici necessari al funzionamento (ad esempio la sessione dell'area riservata) e non usa cookie di profilazione pubblicitaria.",
    ],
  },
  {
    title: "9. Modifiche a questa informativa",
    body: [
      "Questa informativa può essere aggiornata: la versione vigente è sempre quella pubblicata su questa pagina.",
      "Ultimo aggiornamento: settembre 2026.",
    ],
  },
];

export default function Privacy() {
  return (
    <div className="container-site py-16 lg:py-24 max-w-3xl" data-testid="privacy-page">
      <Reveal className="text-center">
        <span className="mx-auto w-14 h-14 rounded-2xl bg-brand-blue text-white flex items-center justify-center">
          <ShieldCheck className="w-7 h-7" />
        </span>
        <h1 className="mt-6 text-4xl sm:text-5xl font-extrabold tracking-tight text-brand-ink">
          Informativa privacy
        </h1>
        <p className="mt-5 text-lg text-slate-600 leading-relaxed">
          La tua fiducia è la cosa più importante per noi. Qui ti spieghiamo, in parole semplici,
          quali dati raccogliamo, perché e quali diritti hai. Riassunto in una frase:{" "}
          <strong className="text-brand-ink">
            i tuoi dati restano con noi, servono solo ad aiutarti e non li cediamo a nessuno.
          </strong>
        </p>
      </Reveal>

      <div className="mt-14 space-y-4">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={Math.min(i * 0.05, 0.3)}>
            <section className="rounded-2xl border border-slate-100 bg-white p-7 shadow-sm" data-testid={`privacy-section-${i + 1}`}>
              <h2 className="text-xl font-extrabold text-brand-ink">{s.title}</h2>
              <ul className="mt-3 space-y-2">
                {s.body.map((p, j) => (
                  <li key={j} className="text-lg text-slate-600 leading-relaxed flex gap-3">
                    {s.body.length > 1 && <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-brand-aqua shrink-0" aria-hidden="true" />}
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </section>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
